import Milegrid from "../../assets/milegrid-logo-svg.svg";
import MyLogo from "./Logo.module.css";

const Logo = () => {

    return <img className={MyLogo.logo} alt='milegrid-logo' src={Milegrid}/>
};

export default Logo;
